import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import { toast } from 'react-toastify';
import { labRequestSurvey } from '../../../helpers/adipiBackendUrl';
import { getTable, postApiCall } from "../../../services/mainServices";
import {
  ADD_NEW_LABREQUESTSURVEY,
  DELETE_LABREQUESTSURVEY,
  GET_LABREQUESTSURVEYS,
  GET_LABREQUESTSURVEYSCALCULATE,
  UPDATE_LABREQUESTSURVEY
} from "./actionTypes";
import {
  addLabRequestSurveyFail,
  addLabRequestSurveySuccess,
  deleteLabRequestSurveyFail,
  deleteLabRequestSurveySuccess,
  getLabRequestSurveysCalculateFail,
  getLabRequestSurveysCalculateSuccess,
  getLabRequestSurveysFail,
  getLabRequestSurveysSuccess,
  setState,
  updateLabRequestSurveyFail,
  updateLabRequestSurveySuccess,
} from "./actions";

//Include Both Helper File with needed methods

function* fetchLabRequestSurveys( { payload: { params } } ) {
  try {
    yield put(setState(true))
    const response = yield call(getTable, labRequestSurvey, params.toString());
    yield put(setState(false))
    yield put(getLabRequestSurveysSuccess(response.items,response.totalPages, response.currentPage));
  } catch (error) {
    yield put(setState(false))
    yield put(getLabRequestSurveysFail(error));
  }
}

function* fetchLabRequestSurveysCalculate( { payload: { params } } ) {
  try {
    yield put(setState(true))
    const response = yield call(getTable, `${labRequestSurvey}/calculate`, params.toString());
    yield put(setState(false))
    yield put(getLabRequestSurveysCalculateSuccess(response));
  } catch (error) {
    yield put(setState(false))
    yield put(getLabRequestSurveysCalculateFail(error));
  }
}

function* updateLabRequestSurvey ({payload: labRequestSurveyObj }) {
  try {
    const response = yield call(getTable,`${labRequestSurvey}/${labRequestSurveyObj.id}`);
    yield put(updateLabRequestSurveySuccess(response));
    toast.success('Registro actualizado correctamente')
  } catch (error) {
    yield put(updateLabRequestSurveyFail(error));
    toast.error('Error al actualizar el registro')
  }
}

function* deleteLabRequestSurvey ({payload: labRequestSurveyObj}) {
  try {
    yield put(deleteLabRequestSurveySuccess(labRequestSurveyObj.id));
    toast.success('Registro borrado correctamente')
  } catch (error) {
    yield put(deleteLabRequestSurveyFail(error));
    toast.error('Error al borrar el registro')
  }
}

function* postingLabRequestSurvey ({ payload: labRequestSurveyObj}) {
  try {
    yield put(setState(true))
    const response = yield call(postApiCall, labRequestSurvey ,labRequestSurveyObj);
    const response1 = yield call(getTable,`${labRequestSurvey}/${response.id}`);
    yield put(addLabRequestSurveySuccess(response1));
    yield put(setState(false))
    toast.success('Registro agregado correctamente')
  } catch (error) {
    yield put(setState(false))
    yield put(addLabRequestSurveyFail(error));
    toast.error('Error al agregar el registro')
  }
}

function* labRequestSurveysSaga() {
  yield takeEvery(GET_LABREQUESTSURVEYS, fetchLabRequestSurveys);
  yield takeEvery(GET_LABREQUESTSURVEYSCALCULATE, fetchLabRequestSurveysCalculate);
  yield takeEvery(ADD_NEW_LABREQUESTSURVEY, postingLabRequestSurvey);
  yield takeEvery(UPDATE_LABREQUESTSURVEY, updateLabRequestSurvey);
  // yield takeEvery(UPDATE_LABREQUESTSURVEY, updateLabRequestSurveyStatus);
  yield takeEvery(DELETE_LABREQUESTSURVEY, deleteLabRequestSurvey);
}

export default labRequestSurveysSaga;
